'use client'

export const IMPERSONATION_SYNC_STORAGE_KEY = 'skop:impersonation-sync'

export function emitImpersonationSync(reason: string): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.setItem(
      IMPERSONATION_SYNC_STORAGE_KEY,
      JSON.stringify({
        reason,
        timestamp: Date.now(),
      }),
    )
  } catch {}
}

export function subscribeToImpersonationSync(
  callback: (reason?: string) => void,
): () => void {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const handleStorage = (event: StorageEvent) => {
    if (event.key !== IMPERSONATION_SYNC_STORAGE_KEY || !event.newValue) {
      return
    }

    try {
      const parsed = JSON.parse(event.newValue) as {
        reason?: string
      }
      callback(parsed.reason)
    } catch {
      callback(undefined)
    }
  }

  window.addEventListener('storage', handleStorage)

  return () => {
    window.removeEventListener('storage', handleStorage)
  }
}
